
import React from "react";

export default function AIChatMessage({ message }) {
  const isUser = message.role === "user";

  return (
    <div
      className={`ai-message-row ${isUser ? "user-message" : "assistant-message"}`}
    >
      <div className="ai-message-avatar">
        {isUser ? "You" : "AI"}
      </div>

      <div className="ai-message-content">
        <div className="ai-message-label">
          {isUser ? "You" : "AI Assistant"}
        </div>

        <div className="ai-message-bubble">
          {message.content}
        </div>
      </div>
    </div>
  );
}
